module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/loading-7fc09f7a20685bfbdccd4d80c9acab59.gif";